import { partnerServices } from "../../config/axios";

// Action Types

import {
    GET_TRANSACTION_CURRENCY_LIST_REQUEST,
    GET_TRANSACTION_CURRENCY_LIST_SUCCESS,
    GET_TRANSACTION_CURRENCY_LIST_FAILURE,
} from '../types';

// Action
export const getTransactionCurrencyListAction = (requestData, authToken) => async (dispatch) => {
    dispatch({ type: GET_TRANSACTION_CURRENCY_LIST_REQUEST });

    console.log("AuthToken being sent:", authToken); 
    
    await partnerServices
        .post("getTransactionCurrencyList", requestData, {
            headers: { AuthToken: authToken }
        })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch({ type: GET_TRANSACTION_CURRENCY_LIST_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: GET_TRANSACTION_CURRENCY_LIST_FAILURE, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: GET_TRANSACTION_CURRENCY_LIST_FAILURE, payload: err.message });
        });
};